import type { FaireProductEntity } from "../../entity_types/product";

export const p_sh4wyskke5: FaireProductEntity = {
  token: "p_sh4wyskke5",
  type: "product",
  name: "Cotton Galaxy Mushroom Print Boho Pants",
  brandToken: "b_ch3tzpim",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ce3b1a2eb3720017b1f8613d38d2931991f23c036b98cc2a73d418e596caeb0e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e4d845e0e6d453d02d198808421989f0074e66e4e7822f4f19aa4e93a756fd98.jpeg",
    "https://cdn.faire.com/fastly/3fabcbc85b032667fd6d2b13115bae1f6f4602696cd9f60d28ede21eb8d2eb20.jpeg",
  ],
  priceDollars: 24.94,
  description:
    "Explore your whimsical side with our Cotton Galaxy Mushroom Print Boho Pants, where cosmic vibes meet earthy charm. Made from soft, breathable cotton, these pants offer all-day comfort with a relaxed, free-flowing fit.\n\nThe unique galaxy-inspired mushroom print adds a playful, artistic touch—perfect for anyone who loves bold, imaginative fashion. Designed with a stretchy waistband and roomy silhouette, they move effortlessly with you, making them ideal for festivals, yoga, travel, or everyday lounging.\n\nNote: This one-of-a-kind item is handmade and may appear in colors other than shown.\n\n100% cotton\nHand wash\nMade in Nepal",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:29.568Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
